import spin from "../../assets/icons/spin.png";

const LoadingDisplay = ({height}) => {
  return (
    <div className={`flex-center-align bg-white ${height ?? "h-full"}`}>
      <div>
        <img src={spin} alt="spin" className="animateSpin" />
        <p className="text-dark-blue lg:text-xl">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingDisplay;
